module.exports = __webpack_public_path__ + "img/product6.50d01533.png";